import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PrimaryButton from "./PrimaryButton";
import { useStores } from "../stores";

const CATEGORIES = [
  { id: "casas", name: "Casas", icon: "fas fa-home" },
  { id: "apartamentos", name: "Apartamentos", icon: "fas fa-building" },
  { id: "lotes", name: "Lotes", icon: "fas fa-mountain" },
  { id: "lojas", name: "Lojas", icon: "fas fa-store" },
  { id: "salas", name: "Salas", icon: "fas fa-door-open" },
  { id: "outros", name: "Outros", icon: "fas fa-th-large" },
];

const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/imoveis/casas", label: "Casas" },
  { path: "/imoveis/apartamentos", label: "Apartamentos" },
  { path: "/imoveis/lotes", label: "Lotes" },
  { path: "/imoveis/lojas", label: "Lojas" },
  { path: "/imoveis/salas", label: "Salas" },
  { path: "/imoveis/outros", label: "Outros" },
];

const Header: React.FC = () => {
  const location = useLocation();
  const [searchCode, setSearchCode] = useState("");
  const { contactStore } = useStores();

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const handleSearchSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (searchCode) {
      window.location.href = `/imovel/${searchCode}`;
    }
  };

  const handleContactClick = () => {
    contactStore.openWhatsApp();
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm py-3">
        <div className="container">
          <a
            className="navbar-brand fw-bold text-uppercase"
            href="/"
            style={{ color: "#0B2545", letterSpacing: "1px" }}
          >
            Imóveis <span className="fw-light text-muted">Mendicino</span>
          </a>

          <div className="d-flex align-items-center d-lg-none gap-2">
            <button
              className="btn btn-link text-dark p-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navSearchMobile"
            >
              <i className="fas fa-search"></i>
            </button>
            <button
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobileMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto gap-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path} className="nav-item">
                  <a
                    href={link.path}
                    className={`nav-link px-1 ${isActive(link.path) ? "active border-bottom border-dark border-2" : ""}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="d-flex align-items-center gap-3">
              <form
                onSubmit={handleSearchSubmit}
                className="position-relative d-none d-md-block"
              >
                <input
                  type="text"
                  className="form-control form-control-sm border-0 bg-light rounded-pill px-3 py-2 pe-4"
                  placeholder="Buscar por código..."
                  value={searchCode}
                  onChange={(e) => setSearchCode(e.target.value)}
                />
                <i
                  className="fas fa-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
                  style={{ fontSize: "0.85rem" }}
                ></i>
              </form>
              <PrimaryButton
                variant="primary"
                size="sm"
                onClick={handleContactClick}
              >
                Falar com Corretor
              </PrimaryButton>
            </div>
          </div>
        </div>
      </nav>

      <div
        className="collapse d-lg-none bg-white border-bottom p-3"
        id="navSearchMobile"
      >
        <form onSubmit={handleSearchSubmit} className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Digite o código do imóvel..."
            value={searchCode}
            onChange={(e) => setSearchCode(e.target.value)}
          />
          <button
            className="btn text-white"
            type="submit"
            style={{ backgroundColor: "#0B2545" }}
          >
            <i className="fas fa-search"></i>
          </button>
        </form>
      </div>

      <div
        className="offcanvas offcanvas-start"
        tabIndex={-1}
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
        style={{ width: "280px" }}
      >
        <div className="offcanvas-header border-bottom py-3 px-4">
          <h5
            className="offcanvas-title fw-bold"
            id="mobileMenuLabel"
            style={{ color: "#0B2545" }}
          >
            Categorias
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body p-3">
          <div className="d-flex flex-column gap-2">
            {CATEGORIES.map((cat) => {
              const catPath = `/imoveis/${cat.id}`;
              const isCatActive = location.pathname.startsWith(catPath);
              return (
                <a
                  key={cat.id}
                  href={catPath}
                  className={`d-flex align-items-center gap-3 p-3 rounded-3 text-decoration-none ${isCatActive ? "text-white" : "text-dark"}`}
                  style={isCatActive ? { backgroundColor: "#13315C" } : {}}
                >
                  <i className={`${cat.icon} fs-5`}></i>
                  <span className="fw-semibold">{cat.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
